import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App';
import './styles/global.scss';
import "react-datepicker/dist/react-datepicker.css";
import { Provider } from "react-redux";
import { store, persistor } from "../src/store/redux-store/root_store";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from 'react-router-dom';

createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
)
